<template>
  <span>
    <b-button :id="'tooltip-target-' + rnd" v-if="buttonType === 'button'">
      <slot name="button-content">
        <translate>Preview</translate>
      </slot>
    </b-button>
    <b-badge :id="'tooltip-target-' + rnd" v-if="buttonType === 'badge'">
      <slot name="button-content">
        <translate>Preview</translate>
      </slot>
    </b-badge>
    <b-tooltip :target="'tooltip-target-' + rnd" triggers="hover" custom-class="tooltip-with-map" boundary-padding="20">
      <l-map
        ref="map"
        id="map"
        :zoom="zoom"
        :center="center"
        style="height: 485px; width: 485px"
        :options="{attributionControl: false}"
        @ready="emitReady"
      >
        <l-tile-layer
          v-for="tileProvider in tileProvidersLocal"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          layer-type="base"
          :options="tileProvider.options"
          v-if="tileProvidersReady"
        />
        <l-control-layers
          position="topright"
          :collapsed="false"
          :sort-layers="true"
          class="text-left"
        />
        <l-control-attribution
          position="bottomright"
          prefix="Moova"
        />
        <l-control-scale position="bottomright" :imperial="imperial" :metric="metric" />
        <l-geo-json
          :geojson="geofence.fence"
          :options-style="optionsStyle"
          :options="options"
        />
        <l-geo-json
          v-for="(geofence, i) in geofence.geo_fences"
          :key="'loadingZone' + i"
          :geojson="geofence.fence"
          :options-style="optionsStyleLoadingZones"
        />
        <l-marker :lat-lng="point" v-for="(point, index) in geofence.geo_points" :key="'point' + index">
          <l-icon
            :icon-anchor="[9, 24]"
            style="position: relative;"
            :tooltipAnchor="[9, -12]"
            :icon-size="[18, 24]"
            >
          <font-awesome-icon icon="map-marker" size="2x" style="filter: drop-shadow(0 0 1px rgba(255,255,255,1)) drop-shadow(0 2px 2px rgba(0,0,0,.3));" :color="point.geo_type.name.includes('entry') ? '#00cc00' : (point.geo_type.name.includes('exit') ? '#cc0000' : '#000')" />
          </l-icon>
        </l-marker>
        <l-marker-cluster :options="{spiderfyDistanceMultiplier: 1, maxClusterRadius: 30}" v-if="!withoutMarkerCluster">
          <map-marker
            v-for="(marker, i) in markers"
            :marker="marker"
            :key="'marker' + i"
          ></map-marker>
        </l-marker-cluster>
        <map-marker
          v-else
          v-for="(marker, i) in markers"
          :marker="marker"
          :key="'marker' + i"
        ></map-marker>
      </l-map>
    </b-tooltip>
  </span>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { GeofenceService } from '@/services/api'
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LGeoJson,
  LMarker,
  LIcon,
  LControlAttribution,
  LControlScale,
  LControlLayers
} from 'vue2-leaflet'
import LMarkerCluster from 'vue2-leaflet-markercluster'
import MapMarker from '@/components/Maps/MapMarker'

export default {
  emits: ['ready'],
  name: 'ListItemFence',
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LMarker,
    LIcon,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LMarkerCluster,
    MapMarker
  },
  props: {
    geofence: {
      type: Object,
      default: () => {}
    },
    buttonType: {
      type: String,
      default: 'button'
    },
    withItems: {
      type: Boolean,
      default: false
    },
    withoutMarkerCluster: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zoom: 15,
      center: [0, 0],
      optionsStyle: {
        weight: 2,
        color: '#cc0000',
        opacity: 1,
        fillColor: '#cc0000',
        fillOpacity: 0.2
      },
      optionsStyleLoadingZones: {
        weight: 2,
        color: '#cc00cc',
        opacity: 1,
        fillColor: '#cc00cc',
        fillOpacity: 0.2
      },
      rnd: Math.random(),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      tileProvidersReady: false,
      tileProvidersLocal: [],
      markers: [],
      imperial: false,
      metric: false
    }
  },
  computed: {
    options() {
      return {
        onEachFeature: this.onEachFeatureFunction
      }
    },
    onEachFeatureFunction() {
      return (feature, layer) => {
        if (this.geofence.geo_type.type === 'polygon' && this.geofence.geo_type.level === 0) {
          const mssg = `<button title="${this.$gettext('Edit this GeoFence')}" type="button" class="btn btn-dark" onclick="window.open('${this.$router.resolve({ name: 'GeofencesEdit', params: { id: this.geofence.id } }).href}')"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="edit" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-edit fa-w-18"><path fill="currentColor" d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" class=""></path></svg></button>`

          layer.bindPopup(
            `<div class="text-center">${mssg}</div>`,
            { permanent: false, sticky: false, closeButton: false }
          )
        }
      }
    }
  },
  watch: {
    tileProviders: {
      handler(newVal, oldVal) {
        this.tileProvidersLocal = cloneDeep(newVal)
        this.setDefaultTileProvider()
      },
      deep: true
    }
  },
  created() {
    this.setDefaultTileProvider()
  },
  mounted() {
    this.imperial = this.frontConfig?.i18n?.unitSystem === 'imperial'
    this.metric = !this.imperial
  },
  methods: {
    async emitReady() {
      this.map = this.$refs.map.mapObject
      this.map.invalidateSize()
      this.mapReady = true
      this.$emit('ready', true)
      /* eslint-disable */
      let geoJSON = L.geoJson(this.geofence.fence)
      this.map.fitBounds(geoJSON.getBounds())
      if (this.withItems) {
        this.fetchItems()
      }
    },
    setDefaultTileProvider() {
      this.tileProvidersLocal = this.tileProviders.map(x => {
        if (x.name === this.ecosystemMaps.defaultTileProvider[this.$options.name]) {
          x.visible = true
        } else {
          x.visible = false
        }
        return x
      })

      this.tileProvidersReady = true
    },
    fetchItems() {
      let params = {
        includes: [
          'item.item_tracking',
          'item.location',
          'item.last_known_location'
        ],
        fields: 'id,reference_code,description,active,item_tracking,last_known_location.external_id,last_known_location.name,last_known_location.reference_location,location.external_id,location.name,location.reference_location,serial_number,shipping,last_position_updated_at'
      }
      GeofenceService.getItems(this.geofence.id, {params})
        .then(response => {
          console.log(response.body)
          if (response.body.length > 0) {
            this.markers = this.transformSelfItems(response.body)
          }
        })
    },
    transformSelfItems(data, type) {
      return data.map((item, i) => {
        console.log(item)
        if (item.item_tracking === null || !item.item_tracking.lat) {
          return false
        }

        // Parse and reformat attributes
        if (item.attributes?.length) {
          item.parsedAttributes = {}
          for (const attribute of item.attributes) {
            item.parsedAttributes[attribute.name] = attribute.value
          }
        } else {
          item.parsedAttributes = null
        }

        let itemColor
        if (this.ecosystemModules.items.icon.colorByMinAge) {
          const daysIdle = this.elapsedTimeRaw(item.last_position_updated_at) / 86400000
          itemColor = this.itemColorByAge(daysIdle, 'items')
        }
        let direction = 0
        if (this.ecosystemModules.items.directionableBy) {
          direction = this.getItemDirection(this.ecosystemModules.items.directionableBy.split('.').reduce((o, i) => o[i], item))
        }

        let dynamic = null
        try {
          if (this.ecosystemModules.items.dynamicableBy) {
            dynamic = this.getItemDynamic(this.ecosystemModules.items.dynamicableBy.split('.').reduce((o, i) => o[i], item))
          }
        } catch (e) {
          console.log(e)
        }

        let load = null
        try {
          if (this.ecosystemModules.items.loadableBy) {
            load = this.ecosystemModules.items.loadableBy.split('.').reduce((o, i) => o[i], item)
          }
        } catch (e) {
          console.assert(e)
        }

        if (item.item_tracking) {
          let infoWindowHtml = ''
          infoWindowHtml += this.$options.filters.cleanentityprefix(item.reference_code)
          return this.transformMarker({
            id: (i + 100000),
            cardType: 'item',
            lat: item.item_tracking.lat,
            lng: item.item_tracking.lng,
            icon: {
              type: this.ecosystemModules.items.icon.type,
              size: this.ecosystemModules.items.icon.size,
              anchor: this.ecosystemModules.items.icon.anchor,
              popupAnchor: this.ecosystemModules.items.icon.popupAnchor,
              color: item.active ? (itemColor || '#000') : '#333',
              text: this.ecosystemModules.items.icon.text || this.$options.filters.cleanentityprefix(item.reference_code),
              direction,
              dynamic,
              load
            },
            x: 30,
            y: 30,
            optimized: false,
            infoText: {
              id: item.id,
              type: 'item-id',
              html: infoWindowHtml,
              color: item.active ? itemColor : '#333',
              data: item,
              isShared: item.isShared || false
            },
            popup: true
          })
        }
      }).filter(Boolean)
    },
    transformMarker(item) {
      return {
        id: item.id,
        position: {
          lat: item.lat,
          lng: item.lng
        },
        icon: typeof item.icon === 'string' ? {
          iconUrl: item.icon,
          iconAnchor: item.anchor || [item.x, item.y],
          iconSize: item.size || [item.x * 2, item.y * 2],
          tooltipAnchor: item.tooltipAnchor || [item.x, 0],
          popupAnchor: item.popupAnchor || [0, -(item.y / 2)]
        } : {
          iconType: item.icon.type,
          iconAnchor: item.icon.anchor,
          iconSize: item.icon.size,
          tooltipAnchor: item.icon.tooltipAnchor || [item.x, 0],
          popupAnchor: item.icon.popupAnchor || [0, -(item.y / 2)],
          iconColor: item.icon.color,
          iconText: item.icon.text,
          iconRotation: item.icon.direction ? (item.icon.direction <= 180 ? item.icon.direction : item.icon.direction - 360) : 0,
          iconDynamic: item.icon.dynamic || null
        },
        infoText: item.infoText,
        tooltip: item.tooltip || null,
        popup: item.popup || null
      }
    }
  }
}
</script>

<style lang="scss">
.tooltip-with-map {
  padding: 30px;
  width: 500px;
  height: 500px;
  .tooltip-inner {
    max-width: none !important;
  }
}
.leaflet-control-layers-list {
  text-align: left;
}
</style>
